import ee from 'event-emitter';

// window.alooma is used by external applications (GTM), so don't remove
window.alooma = window.alooma || {};

class AloomaWrapper {
  constructor() {
    this.ALOOMA_LOADED = 'alooma:loaded';
    this.isAloomaLoaded = false;
    this.registry = {};
    this.sequence = 0;
    this.emitter = ee();
    this.alooma = window.alooma;
  }

  track(eventName, props, cb) {
    return this.waitForAloomaLoaded().then(() => {
      const clone = { ...this.registry, ...props, sequence: this.sequence };
      this.sequence += 1;
      this.alooma.track(eventName, clone, cb);
    });
  }

  register(dataObj) {
    this.registry = { ...this.registry, ...dataObj };
  }

  save(dataObj) {
    return this.waitForAloomaLoaded().then(() => this.alooma.register(dataObj));
  }

  waitForAloomaLoaded() {
    return new Promise(resolve => {
      if (this.isAloomaLoaded) return resolve();
      return this.emitter.on(this.ALOOMA_LOADED, resolve);
    });
  }

  aloomaLoaded() {
    if (!this.isAloomaLoaded) {
      this.alooma.track_pageview();
    }

    this.isAloomaLoaded = true;
    this.emitter.emit(this.ALOOMA_LOADED);
  }
}

// window.aloomaWrapper is used by external applications (GTM), so don't remove
window.aloomaWrapper = new AloomaWrapper();
export { AloomaWrapper };
export default window.aloomaWrapper;



// WEBPACK FOOTER //
// ../utilities/aloomaWrapper.js